import SupportTicketContainer from "../../components/miscellaneous/supportTicket";

const SupportTicket = () => {
  return <SupportTicketContainer />;
};

export default SupportTicket;
